<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">
          Infraestrutura e Tecnologia
        </div>
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="4" :class="espacamentoMobile">
        <div align="right">Possui Prontuário Eletrônico?</div>
      </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          :value="clickSwitch.possuiProntuarioEletronico"
          @input="toggleSwitch('possuiProntuarioEletronico')"
        />
      </unicom-coluna>
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <Multiselect
          v-model="objetoInfraestrutura.prontuarios"
          :propsMultiselect="{
            placeholder: 'Tipo de Prontuário *',
            options: listaProntuario,
            'track-by': 'id',
            label: 'tipoProntuario'
          }"
          :errorMessage="mensagemDeErro.prontuarios"
          v-if="clickSwitch.possuiProntuarioEletronico"
        />
      </unicom-coluna>
      <unicom-coluna
        sm="1"
        :class="espacamentoMobile"
        v-if="outrosProntuarios && clickSwitch.possuiProntuarioEletronico"
      >
        <div align="right" style="font-size: 17px; padding-top: 8px">
          Outros:
        </div>
      </unicom-coluna>
      <unicom-coluna
        sm="3"
        :class="espacamentoMobile"
        v-if="outrosProntuarios && clickSwitch.possuiProntuarioEletronico"
      >
        <unicom-campo-texto
          ladoIcone="direito"
          :maxCaracteres="1500"
          clickIcone
          colorPlaceholder="#9E9E9E"
          placeholder="Outros tipos de Prontuário *"
          v-model="campoOutrosProntuarios"
          :mensagemErro="errors.campoOutrosProntuarios"
        />
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="4" :class="espacamentoMobile">
        <div align="right" style="marginTop: 10px">
          Quais os Modelos de Remuneração Praticado?
        </div>
      </unicom-coluna>
      <unicom-coluna sm="1" />
      <unicom-coluna sm="3" :class="espacamentoMobile">
        <Multiselect
          v-model="objetoInfraestrutura.remuneracoes"
          :propsMultiselect="{
            placeholder: 'Tipo de Remuneração *',
            options: listaRemuneracoes,
            'track-by': 'id',
            label: 'tipoRemuneracao'
          }"
          :errorMessage="mensagemDeErro.remuneracao"
        />
      </unicom-coluna>
      <unicom-coluna
        sm="1"
        :class="espacamentoMobile"
        v-if="outrosRemuneracoes"
      >
        <div align="right" style="font-size: 17px; padding-top: 8px">
          Outros:
        </div>
      </unicom-coluna>
      <unicom-coluna
        sm="3"
        :class="espacamentoMobile"
        v-if="outrosRemuneracoes"
      >
        <unicom-campo-texto
          ladoIcone="direito"
          clickIcone
          :maxCaracteres="1500"
          colorPlaceholder="#9E9E9E"
          placeholder="Outras Remunerações *"
          v-model="campoOutrosRemuneracoes"
          :mensagemErro="errors.campoOutrosRemuneracoes"
        />
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="margin-bottom: 24px" justificarItem="end">
      <unicom-coluna sm="4" :class="espacamentoMobile">
        <div align="right">Possui Serviços Terceirizados?</div>
      </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          :value="clickSwitch.servicosTerceirizados"
          @input="
            clickSwitch.servicosTerceirizados = !clickSwitch.servicosTerceirizados
          "
        />
      </unicom-coluna>

      <unicom-coluna sm="7">
        <unicom-linha
          v-for="servico in packTerceirizados"
          :key="servico.id"
          class="pack-de-forms"
        >
          <unicom-coluna sm="6" :class="espacamentoMobile">
            <single-select
              :value="servico.servico[0]"
              :validacao="true"
              @input="atualizarServicoTerceirizado($event, servico.id)"
              @tem-error="singleSelectErrorHandler($event, servico.id)"
              :propsSingleSelect="{
                placeholder: 'Tipo de Serviço *',
                options: listaServicosTerceirizados,
                'track-by': 'id',
                label: 'tipoServicoTerceirizado'
              }"
              v-if="clickSwitch.servicosTerceirizados"
            />
          </unicom-coluna>

          <unicom-coluna sm="5" :class="espacamentoMobile">
            <custom-campo-texto
              :icone="campoEmpresaContratada ? 'x' : ''"
              :valorError="servico.validacao.campo"
              ladoIcone="direito"
              :maxCaracteres="500"
              clickIcone
              @click-icone="servico.campoEmpresaContratada = ''"
              @tem-error="textoErrorHandler($event, servico.id)"
              colorPlaceholder="#9E9E9E"
              placeholder="Empresa Contratada *"
              v-model="servico.campoEmpresaContratada"
              v-if="clickSwitch.servicosTerceirizados"
            />
          </unicom-coluna>

          <unicom-coluna sm="1" :class="espacamentoMobile">
            <div
              class="remover-campo"
              @click="removerPack(servico.id)"
              v-if="
                clickSwitch.servicosTerceirizados &&
                  packTerceirizados.length > 1
              "
            >
              -
            </div>
          </unicom-coluna>
        </unicom-linha>
        <unicom-coluna sm="12" align="end" :class="espacamentoMobile">
          <div
            class="adicionar-campo"
            @click="adicionarPack"
            v-if="clickSwitch.servicosTerceirizados"
          >
            +
          </div>
        </unicom-coluna>
      </unicom-coluna>
    </unicom-linha>
  </unicom-layout-cartao>
</template>

<script>
import InfraestruturaMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/InfraestruturaMixin";
import Multiselect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";
import SingleSelect from "@/views/RecursosPropriosQuestionarios/shared/Singleselect.vue";
import CustomCampoTexto from "@/views/RecursosPropriosQuestionarios/shared/CampoTexto/CampoTexto.vue";

export default {
  mixins: [InfraestruturaMixin],
  components: {
    Multiselect,
    SingleSelect,
    CustomCampoTexto
  },
  data() {
    return {};
  },
  methods: {
    toggleSwitch(campo) {
      return (this.clickSwitch[campo] = !this.clickSwitch[campo]);
    }
  },
  computed: {
    /**
     * Verifica se a tela está no viewport mobile e se estiver, retorna uma classe que da o espaçamento para cima
     */
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    }
  }
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
.adicionar-campo,
.remover-campo {
  margin: auto;
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  background: #00995d;
  text-align: center;
  font-size: 2rem;
  color: #fff;
  border-radius: 50%;
  user-select: none;
}
.pack-de-forms {
  margin-bottom: 1rem;
}
</style>
